<section id="iq-home" class="introduce">
    <img data-wow-delay="1s" src="{{imagesUrl}}/circle-element.png" alt="" class="circle-element fadeInLeft wow">
    <img data-wow-delay="1s" src="{{imagesUrl}}/triangle-element.png" alt="" class="triangle-element fadeInLeft wow">
    <img data-wow-delay="1s" src="{{imagesUrl}}/triangle-element.png" alt="" class="triangle-element-2 fadeInLeft wow">
    <img data-wow-delay="1s" src="{{imagesUrl}}/x-element.png" alt="" class="x-element rotateme fadeInLeft wow">
    <img data-wow-delay="1s" src="{{imagesUrl}}/x-orange-element.png" alt="" class="x-element-2 rotateme fadeInLeft wow">
    <!-- <div class="shape"></div> -->

    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 white-text slider-text pt-custom">
                <h2 class="mb-2 text-right bold header" dir="rtl">
                    נעים להכיר -
                    <span class="name">דיגיטל לובי</span>
                    <br>
                    <span>
                        {{header2}}
                    </span>
                </h2>
                <h4 class="mb-2 text-right sub-header" dir="rtl">
                    {{text1}}
                </h4>
                <h4 class="mb-2 text-right sub-header" dir="rtl">
                    {{text2}}
                </h4>
                <div class="wow fadeInUp" data-wow-delay="2s">
                    <a class="button-gradient" (click)="joinUsClick()" href="https://wa.me/545602139?text={{buttonText}}">הצטרפו עכשיו</a>
                    <!-- <button class="button-gradient" (click)="joinus('join')">הצטרפו עכשיו</button> -->
                </div>
            </div>
            <div class="col-lg-6 element-container">
                <div class="slider-element-container">
                    <img data-wow-delay="0.5s" src="{{imagesUrl}}/slider-element1.png" alt=""
                        class="slider-element fadeInUp wow">
                    <!-- <img src="{{imagesUrl}}/shadow.png" alt="" class="slider-shadow"> -->
                    <!-- <img data-wow-delay="1s" src="{{imagesUrl}}/slider-element-1.png" alt="" class="slider-element-1 fadeInleft wow"> -->
                    <img data-wow-delay="1s" src="{{imagesUrl}}/slider-element-1.png" alt=""
                        class="slider-element-1 fadeInLeft wow">
                    <img data-wow-delay="1s" src="{{imagesUrl}}/slider-element-2.png" alt=""
                        class="slider-element-2 fadeInRight wow">
                    <img data-wow-delay="1s" src="{{imagesUrl}}/slider-element-3.png" alt=""
                        class="slider-element-3 fadeInLeft wow">
                    <img data-wow-delay="1s" src="{{imagesUrl}}/slider-element-4.png" alt=""
                        class="slider-element-4 fadeInRight wow">
                    <img data-wow-delay="1s" src="{{imagesUrl}}/slider-element-5.png" alt=""
                        class="slider-element-5 fadeInUp wow">
                    <img data-wow-delay="1s" src="{{imagesUrl}}/slider-element-6.png" alt=""
                        class="slider-element-6 fadeInUp wow">
                </div>
                <!-- <div class="video-container" *ngIf="videoUrl">

                    <video id="my_video_1" class="video-js vjs-default-skin" width="640px" controls preload="none"
                        poster='{{imagesUrl}}{{imageUrl}}'>
                        <source src="{{imagesUrl}}{{videoUrl}}" type='video/mp4' />
                    </video>
                </div>
                <div *ngIf="videoUrl===''">
                    <img src="{{imagesUrl}}{{imageUrl}}" alt="">
                </div> -->
            </div>
        </div>
    </div>
</section>